<!-- 
    *@FileDescription: 头部
    *@Author: swt
    *@LastEditors: swt
    *@LastEditTime: 2023.10.7
 -->
<template>
    <div class="top-container">
        <div class="title">
        </div>
        <div class="right">
            <!-- <div class="changeTheme">
                <el-button title="更换主题" round icon="el-icon-s-open" @click="changeTheme"></el-button>
            </div> -->
            <!-- <div style="margin-right: 30px;">
                <el-badge :value="200" :max="99" class="item" type="primary">
                    <el-button round icon="el-icon-bell" @click="goSystemMessage"></el-button>
                </el-badge>
            </div> -->
            <!-- <div class="date">{{ date }}</div>
            <div class="time" style="width:100px">{{ time }}</div> -->
            <div class="time">{{ userInfo.name }}</div>
            <div class="line"></div>
            <el-dropdown placement="bottom">

                <div class="el-dropdown-link">
                    <el-avatar icon="el-icon-user-solid" :size="30"></el-avatar>
                </div>
                <el-dropdown-menu slot="dropdown" class="header-new-drop">
                    <el-dropdown-item @click.native="changePassword">修改密码</el-dropdown-item>
                    <el-dropdown-item @click.native="logout">退出登录
                    </el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
        </div>
        <ChangePassword ref="changePassword"></ChangePassword>
    </div>
</template>
<script>
import ChangePassword from "./ChangePassword.vue";
import dayjs from "dayjs";
export default {
    name: 'AppHeader',
    created() {
        this.getNowTime();
    },
    data() {
        return {
            date: '',
            time: '',
            userInfo: {}
        }
    },
    components: {
        ChangePassword,
    },
    created() {
        this.userInfo = localStorage.getItem("userInfo") ? JSON.parse(localStorage.getItem("userInfo")) : {}
    },
    methods: {
        /**
    * 修改密码
    */
        changePassword() {
            this.$refs.changePassword.openDialog();
        },
        logout() {
            localStorage.clear()
            this.$router.push('/login')
        },
        getNowTime() {
            setInterval(() => {
                this.date = dayjs(new Date()).format("YYYY/MM/DD");
                this.time = dayjs(new Date()).format("HH:mm:ss");
            }, 1000);
        },
        // 切换主题
        changeTheme() {
            let themeNow = sessionStorage.getItem('theme')
            if (themeNow === 'light') {
                // return "white"
                this.$emit('changeTheme', 'light')
                sessionStorage.setItem('theme', 'dark')
            } else {
                // return "black"
                this.$emit('changeTheme', "dark")
                sessionStorage.setItem('theme', 'light')
            }
        },
        goSystemMessage() {
            this.$router.push('/SystemMessage')
        }
    }
}
</script>
<style lang="less" scoped>
.top-container {
    width: 100%;
    height: 80px;
    display: flex;
    flex-direction: row;
    align-items: center;
    // border-bottom: solid 1px #e6e6e6;

    .title {
        font-size: 20px;
    }

    .right {
        height: 100%;
        width: 500px;
        flex: 1;
        margin-right: 20px;
        display: flex;
        align-items: center;
        justify-content: end;

        .date,
        .time {
            height: 100%;
            font-size: 16px;
            color: #666;
            line-height: 80px;
            text-align: right;
            padding-right: 10px;
        }
    }
}

.el-dropdown-link {
    width: 30px;
    height: 30px;
    cursor: pointer;

    span {
        display: block;
    }
}

.el-dropdown {
    width: 30px;
    height: 30px;
    font-size: 30px;
}

.changeTheme {
    margin-right: 25px;

    .el-icon-s-open {
        width: 100%;
        height: 100%;
        cursor: pointer;
    }
}

:deep .el-badge__content--primary {
    background-color: #5A45AA;
}
</style>